import { css } from 'styled-components';
import { themeGet, is } from '../../../theme/utils';
import { ButtonBaseProps } from '../Button';

const clean = css<ButtonBaseProps>`
  color: ${themeGet.colors('kilamanjaro')};

  box-shadow: none;
  &:hover {
    box-shadow: none;
  }
  padding: 0 ${themeGet.space(2)};
  ${is('disabled')`
    color: ${themeGet.colors('swirl')};
  `};
`;

export default clean;
